{
    "filterConfig": {
      "filterFields": [ 
          {
              "name": "arrivalContainerIds.containerNo",
              "displayLabel": "Container No",
              "dataType": "STRING",
              "supportedOperators": ["EQ_CIS", "NE_CIS"]
          },
          {
            "name": "igmItemNo",
            "displayLabel": "IGM Item No",
            "dataType": "STRING",
            "supportedOperators": ["EQ_CIS", "NE_CIS"]
          },
          {
              "name": "chaId",
              "displayLabel": "CHA",
              "dataType": "STRING",
              "hasLookup": true,
              "searchConfig": {
                  "apiUrl": "v1/customers/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ],
                  "additionalFilters":[
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": ["true"]
                  },
                  {
                    "name": "CUSTOMER_TYPE_CONTAINS",
                    "alias": "customerType",
                    "operator": "IN",
                    "value": ["CHA"]
                  }
                ]
              }
          },
          {
            "name": "accountHolderId",
            "displayLabel": "Account Holder",
            "dataType": "STRING",
            "hasLookup": true,
            "searchConfig": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": ["NAME_CONTAINS"],
                "limit": 10,
                "orderBy": { "name": "asc" },
                "bindLabel": "name",
                "bindValue": "id",
                "additionalFilters": [{
                  "name": "IS_ACTIVE",
                  "alias": "active",
                  "operator": "EQ",
                  "value": ["true"]
                }],
                "displayColumns": [
                  { "key": "name", "header": "Name" }
                ]
            }
        },
          {
            "name": "vesselId",
            "displayLabel": "Vessel Name",
            "dataType": "STRING",
            "hasLookup": true,
            "searchConfig": {
                "apiUrl": "v1/vessel-port-train-details/list?useNewContract=true",
                "selectFields": ["id", "vesselName"],
                "filterByKeys": ["VESSEL_NAME_CONTAINS"],
                "limit": 10,
                "orderBy": { "vesselName": "asc" },
                "bindLabel": "vesselName",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "vesselName", "header": "Vessel Name" }
                ],
                "additionalFilters":{
                  "name": "IS_ACTIVE",
                  "alias": "active",
                  "operator": "EQ",
                  "value": ["true"]
                }
            }
        },
        {
          "name": "viaNo",
          "displayLabel": "VIA No",
          "dataType": "STRING",
          "hasLookup": true,
          "searchConfig": {
              "apiUrl": "v1/vessel-port-train-details/list?useNewContract=true",
              "selectFields": ["id", "vesselName"],
              "filterByKeys": ["VIA_NO_CONTAINS"],
              "limit": 10,
              "orderBy": { "viaNo": "asc" },
              "bindLabel": "vesselName",
              "bindValue": "id",
              "displayColumns": [
                { "key": "viaNo", "header": "Via No" }
              ],
              "additionalFilters":{
                "name": "IS_ACTIVE",
                "alias": "active",
                "operator": "EQ",
                "value": ["true"]
              }
          }
      },
        {
          "name": "shippingLineId",
          "displayLabel": "Shipping Line",
          "dataType": "STRING",
          "hasLookup": true,
          "searchConfig": {
              "apiUrl": "v1/customers/list",
              "selectFields": ["id", "name", "code"],
              "filterByKeys": ["name", "code"],
              "limit": 10,
              "orderBy": { "name": "asc" },
              "bindLabel": "name",
              "bindValue": "id",
              "displayColumns": [
                { "key": "name", "header": "Name" }
              ],
              "additionalFilters":[
                {
                  "name": "active",
                  "alias": "active",
                  "operator": "EQ",
                  "value": ["true"]
                },
                {
                  "name": "customerType",
                  "alias": "customerType",
                  "operator": "IN",
                  "value": ["LINE"]
                }
              ]
          }
      },
          {
            "name": "boeNo",
            "displayLabel": "BOE No",
            "dataType": "STRING",
            "supportedOperators": ["EQ_CIS", "NE_CIS"]
          },
        
          {
            "name": "blNo",
            "displayLabel": "MBL No",
            "dataType": "STRING",
            "supportedOperators": ["EQ_CIS", "NE_CIS"]
          },
          {
            "name": "hblNo",
            "displayLabel": "HBL No",
            "dataType": "STRING",
            "supportedOperators": ["EQ_CIS", "NE_CIS"]
          }
      ]
    },
    "tableConfig": {
      "name": "hold",
      "dbName": "hold",
      "uniqueColumns": ["cargoId", "containerId"],
      "columns": [
        {
          "fieldName": "containerNo",
          "displayName": "Container No",
          "dataType": "STRING"
        },
        {
          "fieldName": "igmItemNo",
          "displayName": "IGM Item No",
          "dataType": "STRING"
        },
        {
            "fieldName": "vesselName",
            "displayName": "Vessel Name",
            "dataType": "STRING"
        },
        {
          "fieldName": "accountHolder",
          "displayName": "Account Holder",
          "dataType": "STRING"
        },
        {
          "fieldName": "cha",
          "displayName": "CHA",
          "dataType": "STRING"
        },
        {
            "fieldName": "importType",
            "displayName": "ImportType",
            "dataType": "STRING"
          },
        {
            "fieldName": "blNo",
            "displayName": "MBL No",
            "dataType": "STRING"
        },
        {
            "fieldName": "hblNo",
            "displayName": "HBL No",
            "dataType": "STRING"
        }
      ]
    }
  }